import script from "./OrdersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersTable.vue?vue&type=script&setup=true&lang=js"

import "./OrdersTable.vue?vue&type=style&index=0&id=316c833a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-316c833a"]])

export default __exports__